import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import theme from '../LayoutComponents/theme';

export default function SelectCourses({ label, entities, selected, setSelected }) {
  const handleChange = (event) => {
    setSelected(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        multiple
        value={selected}
        onChange={handleChange}
        renderValue={(selected) =>
          entities
            ?.filter((entity) => selected?.includes(entity.courseId))
            ?.map((entity) => entity.name)
            ?.join(", ")
        }
        variant="standard"
      >
        {entities?.map((entity) => (
          <MenuItem key={entity.id} value={entity.id}>
            <Checkbox checked={selected?.indexOf(entity?.id) > -1}
              sx={{
                color: theme.colors.purple,
                '&.Mui-checked': {
                  color: theme.colors.purple,
                },
              }} />
            <ListItemText primary={entity?.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}